import { render, staticRenderFns } from "./Agendamentos.vue?vue&type=template&id=574e1b6f"
import script from "./Agendamentos.vue?vue&type=script&lang=js"
export * from "./Agendamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports